import { Notification, variants } from '@eti/components';
import { Button, Dialog, Inline, LinkButton, Text } from '@etg/wings';
import { useCallback, useState } from 'react';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import TextWithButton from './TextWithButton';

const notificationTextStyles = css`
  max-width: 40em;
`;

interface DifferentChargingCurrencyNotificationProps {
  className?: string;
}

const DifferentChargingCurrencyNotification = ({
  className,
}: DifferentChargingCurrencyNotificationProps) => {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isNotificationDismissed, setIsNotificationDismissed] = useState(
    () => sessionStorage.getItem('differentChargingCurrencyNotificationDismissed') === 'yes',
  );

  const handleCloseNotification = useCallback(() => {
    sessionStorage.setItem('differentChargingCurrencyNotificationDismissed', 'yes');
    setIsNotificationDismissed(true);
  }, []);

  if (isNotificationDismissed) {
    return null;
  }

  return (
    <div className={className}>
      <Notification
        dataTestId="different-charging-currency-notification"
        onClose={handleCloseNotification}
        variant={variants.INFORMATION}
      >
        <TextWithButton
          button={
            <LinkButton
              data-testid="different-charging-currency-notification-button"
              onClick={() => setIsDialogOpen(true)}
            >
              {t('DifferentChargingCurrency.Notification.Button')}
            </LinkButton>
          }
          className={notificationTextStyles}
          content={t('DifferentChargingCurrency.Notification.Text')}
        />
      </Notification>

      <Dialog
        closeButtonAriaLabel={t('ScreenReader.CloseButtonDialog.AriaLabel.Text')}
        data-testid="different-charging-currency-dialog"
        footer={
          <Inline align="end">
            <Button
              data-testid="different-charging-currency-dialog-button"
              onClick={() => setIsDialogOpen(false)}
              variant="primary"
            >
              {t('DifferentChargingCurrency.Notification.Dialog.Continue.Button')}
            </Button>
          </Inline>
        }
        isOpen={isDialogOpen}
        onDismiss={() => setIsDialogOpen(false)}
        title={t('DifferentChargingCurrency.Notification.Dialog.Heading')}
      >
        <Text asHtml>{t('DifferentChargingCurrency.Notification.Dialog.Description')}</Text>
      </Dialog>
    </div>
  );
};

export default DifferentChargingCurrencyNotification;
